import React from 'react';
import { Stack, Typography, Input, Box, Sheet } from '@mui/joy';

const JsonNodeEditor = ({ nodeKey, value, depth = 0, onChange }) => {
  if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
    return (
      <Box sx={{ pl: depth > 0 ? 1.5 : 0, borderLeft: depth > 0 ? '2px solid' : 'none', borderColor: 'neutral.200' }}>
        {nodeKey !== null && (
          <Typography level="body-xs" sx={{ color: 'neutral.300', fontFamily: 'monospace', mb: 0.5 }}>
            {nodeKey}
          </Typography>
        )}
        <Stack spacing={1}>
          {Object.entries(value).map(([k, v]) => (
            <JsonNodeEditor
              key={k}
              nodeKey={k}
              value={v}
              depth={depth + 1}
              onChange={(newVal) => onChange({ ...value, [k]: newVal })}
            />
          ))}
        </Stack>
      </Box>
    );
  }

  if (Array.isArray(value)) {
    return (
      <Box sx={{ pl: depth > 0 ? 1.5 : 0, borderLeft: depth > 0 ? '2px solid' : 'none', borderColor: 'neutral.200' }}>
        {nodeKey !== null && (
          <Typography level="body-xs" sx={{ color: 'neutral.300', fontFamily: 'monospace', mb: 0.5 }}>
            {nodeKey}
          </Typography>
        )}
        <Stack spacing={1}>
          {value.map((item, i) => (
            <JsonNodeEditor
              key={i}
              nodeKey={`[${i}]`}
              value={item}
              depth={depth + 1}
              onChange={(newVal) => {
                const updated = [...value];
                updated[i] = newVal;
                onChange(updated);
              }}
            />
          ))}
        </Stack>
      </Box>
    );
  }

  // Primitive leaf
  const inputType = typeof value === 'number' ? 'number' : 'text';
  return (
    <Sheet variant="outlined" sx={{ p: 1.5, borderRadius: 'sm' }}>
      <Stack spacing={0.5}>
        {nodeKey !== null && (
          <Typography level="body-xs" sx={{ color: 'neutral.300', fontFamily: 'monospace' }}>
            {nodeKey}
          </Typography>
        )}
        <Input
          size="sm"
          type={inputType}
          value={value ?? ''}
          onChange={(e) => {
            const raw = e.target.value;
            onChange(inputType === 'number' ? (raw === '' ? '' : Number(raw)) : raw);
          }}
        />
      </Stack>
    </Sheet>
  );
};

const JsonValueEditor = ({ value, onChange }) => {
  let parsed;
  try {
    parsed = value !== null && value !== undefined
      ? (typeof value === 'object' ? value : JSON.parse(value))
      : null;
  } catch {
    return null;
  }

  if (parsed === null || parsed === undefined) return null;

  return (
    <JsonNodeEditor
      nodeKey={null}
      value={parsed}
      depth={0}
      onChange={(newVal) => onChange(JSON.stringify(newVal))}
    />
  );
};

export default JsonValueEditor;
